module.exports = __webpack_public_path__ + "static/media/eh.780a0a9e.svg";